import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { OriginalInputState } from '../type/ai-translation.type';
import { SupportedLanguage } from '../type/ai-translation.enum';

export const OriginalInputModel = Symbol('OriginalInputModel');

export interface OriginalInputModel extends AbstractModel<OriginalInputState> { }

@injectable()
export class OriginalInputModelImpl extends AbstractModelImpl<OriginalInputState> implements OriginalInputModel {
    protected _modelData: OriginalInputState = {
        input: '',
        sourceLang: SupportedLanguage.CN,
        targetLang: SupportedLanguage.EN,
        isSupportLang: true,
    };
}
